export default [
    {
      path: '/admin/counters',
      name: 'counter',
      meta: { requiresAuth: true },
      component: () => import('@/pages/counter/index.vue')
    }
  ]
  